// src/services/itemDeliveryLogService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getItemDeliveryLogs = async () => {
  return await axios.get(`${API_URL}/item-delivery-logs`);
};

const getItemDeliveryLog = async (id) => {
  return await axios.get(`${API_URL}/item-delivery-logs/${id}`);
};

const createItemDeliveryLog = async (itemDeliveryLogData) => {
  return await axios.post(`${API_URL}/item-delivery-logs`, itemDeliveryLogData);
};

const updateItemDeliveryLog = async (id, itemDeliveryLogData) => {
  return await axios.put(`${API_URL}/item-delivery-logs/${id}`, itemDeliveryLogData);
};

const deleteItemDeliveryLog = async (id) => {
  return await axios.delete(`${API_URL}/item-delivery-logs/${id}`);
};

export default {
  getItemDeliveryLogs,
  getItemDeliveryLog,
  createItemDeliveryLog,
  updateItemDeliveryLog,
  deleteItemDeliveryLog,
};
